import { z } from 'zod';

export enum IntervalAdjustmentFormKeys {
    Arrival = 'arrival',
    Departure = 'departure',
    CreateNewReservation = 'createNewReservation',
    CreateNewReservationRateId = 'rateId',
    ApplyCancellationFee = 'applyCancellationFee',
}

export const IntervalAdjustmentFormSchema = z.object({
    [IntervalAdjustmentFormKeys.Arrival]: z.string().datetime().optional(),
    [IntervalAdjustmentFormKeys.Departure]: z.string().datetime().optional(),
    [IntervalAdjustmentFormKeys.ApplyCancellationFee]: z.boolean(),
    [IntervalAdjustmentFormKeys.CreateNewReservation]: z.boolean(),
    [IntervalAdjustmentFormKeys.CreateNewReservationRateId]: z.string(),
});

export type IntervalAdjustmentFormValues = z.infer<typeof IntervalAdjustmentFormSchema>;
